import { HouseType } from '../graphql.generated';

export const getHouseTypeString = (propertyTypeCode: string) =>
    (({
        D: 'DETACHED',
        F: 'FLAT',
        S: 'SEMI_DETACHED',
        T: 'TERRACED'
    }[propertyTypeCode] ?? 'ALL') as HouseType);
